import React, { useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getRdxActionMapper, getRdxSelectionMapper } from "rdx/utils/propsMapping";
import { useTranslation } from "react-i18next";
import { Form, Radio, Space } from "antd";
import GradientButton from "components/Buttons/GradientButton";
import styles from "./ExperienceLevel.module.less";

const ExperienceLevel = ({ handleContinue, regInfo, updateRegistration }) => {
  const { t } = useTranslation(["join", "form_labels"]);
  const formValues = useRef({});
  const [form] = Form.useForm();

  const onContinue = () => {
    formValues.current = { ...formValues.current, ...form.getFieldsValue() };

    form
      .validateFields(["experience"])
      .then(() => {
        updateRegistration({ ...formValues.current, slug: regInfo.slug });
        handleContinue();
      })
      .catch((errors) => console.warn(errors));
  };

  return (
    <div className={styles.accountTypeContainer}>
      <Form onFinish={onContinue} form={form} initialValues={regInfo}>
        <div className={styles.experienceLevelContainer}>
          <div className={styles.label}>{t("join_form.experience_level")}</div>
          <div className={styles.experienceForm}>
            <Form.Item
              name="experience"
              className={styles.experienceRadioGroup}
              rules={[
                {
                  required: true,
                  message: t("join_form.experience_required"),
                },
              ]}
            >
              <Radio.Group size="large">
                <Space direction="vertical">
                  <Radio value="no_experience">{t("join_form.no_experience")}</Radio>
                  <Radio value="some_experience">{t("join_form.some_experience")}</Radio>
                  <Radio value="expert">{t("join_form.expert")}</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item noStyle shouldUpdate>
              {({ getFieldsValue }) => {
                const { experience } = getFieldsValue();
                return (
                  <GradientButton
                    type="primary"
                    htmlType="submit"
                    className={styles.continueButton}
                    disabled={!experience}
                  >
                    {t("join_form.continue")}
                  </GradientButton>
                );
              }}
            </Form.Item>
          </div>
        </div>
      </Form>
    </div>
  );
};

ExperienceLevel.propTypes = {
  handleContinue: PropTypes.func,
  regInfo: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    id: PropTypes.number,
    inviteAt: PropTypes.string,
    createdAt: PropTypes.string,
    roleTags: PropTypes.arrayOf(PropTypes.string),
    locale: PropTypes.string,
    spokenLanguages: PropTypes.arrayOf(PropTypes.string),
    slug: PropTypes.string,
    kind: PropTypes.string,
    manualKindSelection: PropTypes.bool,
    confirmed: PropTypes.bool,
    dob: PropTypes.string,
    accountType: PropTypes.string,
    experience: PropTypes.string,
  }),
  updateRegistration: PropTypes.func,
};
export default connect(getRdxSelectionMapper({}), getRdxActionMapper(["updateRegistration"]))(ExperienceLevel);
